var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconRvAmenityPicnicTable = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.967 4H5.5C4.67 4 4 4.67 4 5.5S4.67 7 5.5 7h2.283l-1.8 4.5H2.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h21c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-3.483l-1.8-4.5H20.5c.83 0 1.5-.67 1.5-1.5S21.33 4 20.5 4h-4.537.004zm5.85 12h-3.234l2.025 5.058a1.5 1.5 0 1 0 2.784-1.116L21.817 16zm-14.4 0H4.183l-1.575 3.942a1.5 1.5 0 1 0 2.784 1.116L7.417 16zm1.8-4.5 1.8-4.5h3.97l1.8 4.5h-7.57z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconRvAmenityPicnicTable, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-rv-amenity-picnic-table.0aaf0ea5.svg";
export { ForwardRef as ReactComponent };